var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoProfileChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 62,
    viewBox: "0 0 36 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6796 28.3066L8.80511 3.99895C7.41515 2.66702 5.28934 2.66702 3.98115 3.99895C2.67295 5.33088 2.67295 7.49526 3.98115 8.91043L25.4846 30.804L3.98115 52.6976C2.67295 54.0295 2.67295 56.2772 3.98115 57.6091C5.28934 58.941 7.41515 58.941 8.80511 57.6091L32.6796 33.2181C33.9878 31.8862 33.9878 29.7218 32.6796 28.3066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoProfileChevron);
export default __webpack_public_path__ + "static/media/go-profile-chevron.3113b817a9d8249648e7b1db87ec2ae7.svg";
export { ForwardRef as ReactComponent };